import NormalAPI from "../../api";
import urls from "../../api/urls";

export const getMcnShipments = async (params) => {
  let activeHub = JSON.parse(localStorage.getItem("active_hub") || "{}");
  let userId = JSON.parse(localStorage.getItem("userId") || "{}");
  let currentPremiseId = activeHub?.hubId || userId?.userInfo?.premiseId;

  const {
    partnerCode = "",
    bookingType = "",
    from,
    to,
    page = 1,
    size = 10,
    search = "",
    bookingStatus = null,
    checkDestinationHubMatch = false,
    checkDestinationHub = false,
    currentOperationCode = null
  } = params;

  try {
    // Construct query parameters following the same pattern as getMCNListReport
    const queryParams = {
      from: from,
      to: to,
      ...(partnerCode && { partnerCode }),
      ...(bookingType && { bookingType }),
      ...(search && { search }),
      ...(bookingStatus && { bookingStatus }),
      ...(currentOperationCode && { currentOperationCode }),
      ...(checkDestinationHubMatch && { checkDestinationHubMatch: checkDestinationHubMatch.toString() }),
      ...(checkDestinationHub && { checkDestinationHub: checkDestinationHub.toString() }),
      page: page - 1, // API expects 0-based pagination
      size: size
    };
    // Remove undefined values
    const cleanParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value != null)
    );
    const queryString = new URLSearchParams(cleanParams).toString();

    console.log("getMcnShipments params:", cleanParams);

    const response = await NormalAPI.Api(urls.GET_MCN_LIST + "/" + currentPremiseId + "?" + queryString)
      .getCustomHeader(cleanParams);

    if (response?.response?.status === 200) {
      return {
        data: response?.response?.data?.data || [],
        total: response?.response?.data?.count || 0,
        page: page,
        size: size
      };
    } else {
      throw new Error(response?.response?.data?.message || "API request failed");
    }
  } catch (error) {
    console.error("Error fetching MCN shipments:", error);
    throw error;
  }
};

// Manual filter utilities following the patterns used in the application
export const getColumnSearchProps = (dataIndex, filterList = null) => {
  if (filterList) {
    // For predefined filter lists (like status, types, etc.)
    return {
      filters: filterList.map((value) => ({
        text: value,
        value: value,
      })),
      onFilter: (value, record) => record[dataIndex]?.includes(value),
      filterSearch: true,
    };
  }

  // For custom search filters - returns filter configuration for Ant Design Table
  return {
    filterDropdown: true, // Enable filter dropdown
    filterIcon: (filtered) => ({
      type: "search",
      style: { color: filtered ? "#1890ff" : undefined }
    }),
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    filterSearch: true,
  };
};

// General search filter function
export const filterArray = (dataSource, searchValue) => {
  if (!searchValue || searchValue.length === 0) return dataSource;

  return dataSource?.filter((record) =>
    Object.keys(record).some((key) =>
      String(record[key]).toLowerCase().includes(searchValue.toLowerCase())
    )
  );
};

// Advanced filter function for multiple criteria
export const applyAdvancedFilters = (data, filters) => {
  if (!filters || Object.keys(filters).length === 0) return data;

  return data.filter((record) => {
    return Object.entries(filters).every(([key, filterValue]) => {
      if (!filterValue || filterValue.length === 0) return true;

      const recordValue = record[key];
      if (Array.isArray(filterValue)) {
        // For multiple values (multi-select filters)
        return filterValue.some(value =>
          String(recordValue).toLowerCase().includes(String(value).toLowerCase())
        );
      } else {
        // For single values
        return String(recordValue).toLowerCase().includes(String(filterValue).toLowerCase());
      }
    });
  });
};

// Date range filter utility
export const filterByDateRange = (data, dateField, startDate, endDate) => {
  if (!startDate || !endDate) return data;

  const start = new Date(startDate);
  const end = new Date(endDate);

  return data.filter((record) => {
    const recordDate = new Date(record[dateField]);
    return recordDate >= start && recordDate <= end;
  });
};

// Status filter utility
export const getStatusFilterOptions = (data, statusField) => {
  const uniqueStatuses = [...new Set(data.map(item => item[statusField]).filter(Boolean))];
  return uniqueStatuses.map(status => ({
    text: status,
    value: status,
  }));
};

// Helper function to format date to dd-MM-yyyy format
export const formatDateForApi = (date) => {
  if (!date) return null;

  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  return `${day}-${month}-${year}`;
};

// Default date range (1 week: 7 days ago to today)
export const getDefaultDateRange = () => {
  const today = new Date();
  const weekAgo = new Date(today);
  weekAgo.setDate(today.getDate() - 7);

  const formattedWeekAgo = formatDateForApi(weekAgo);
  const formattedToday = formatDateForApi(today);

  return { from: formattedWeekAgo, to: formattedToday };
};
